import create from './create'
import deleteLang from './delete'
import status from './status'

export default {
    create,
    'delete': deleteLang,
    status
}